import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Front from '@frontapp/plugin-sdk';

// List of paths that should open in a new window when in Front
const RESTRICTED_PATHS = [
  '/dashboard/channels',
  '/dashboard/recordings',
  '/dashboard/call-routings',
  '/dashboard/call-route/',
  '/dashboard/settings'
];

const FrontRouteGuard = ({ children }) => {
  const location = useLocation();
  const [isFrontPlugin, setIsFrontPlugin] = useState(false);

  useEffect(() => {
    const checkFrontPlugin = async () => {
      try {
        const subscribe = Front.contextUpdates.subscribe((context) => {
          console.log('Front context in guard:', context);
          setIsFrontPlugin(!!context);
        });
        return () => subscribe.unsubscribe();
      } catch (error) {
        console.log('Not running as Front plugin:', error);
        setIsFrontPlugin(false);
      }
    };
    checkFrontPlugin();
  }, []);

  useEffect(() => {
    if (isFrontPlugin && RESTRICTED_PATHS.some(path => location.pathname.startsWith(path))) {
      const fullUrl = window.location.origin + location.pathname + location.search;
      console.log('Opening in new window:', fullUrl);
      Front.openUrl(fullUrl);
      // Prevent the restricted page from loading in Front
      window.history.back();
    }
  }, [location.pathname, location.search, isFrontPlugin]);

  return children;
};

export default FrontRouteGuard; 